import React from 'react'
import QuestionnaireContainer from './Questionnaires/QuestionnaireContainer'

export default function WorkFlowQuestionnaireSection({ questionnaireAssignments }) {
  return (
    <QuestionnaireContainer questionnaires={questionnaireAssignments} />
  )
}
